import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';
import { Button, IconButton, Dialog, DialogContent, Card, CardContent, Tooltip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { MonetizationOnOutlined as MonetizationOnOutlinedIcon } from '@mui/icons-material';
import { Info as InfoIcon } from '@mui/icons-material';
import './MCTQuoteCard.scss';

export default function DisabilityInsuranceCard(props) {
    const [isProductDetailsDialogOpen, setIsProductDetailsDialogOpen] = useState(false);

    const getBadge = () => {
        var bestCount = [props.requiresMedicalExam].filter((f) => f === true).length;

        // now either it only has 1 badge, or it doesn't have the badge being sorted by, so pick one

        if (bestCount && props.requiresMedicalExam) {
            return (
                <Fragment>
                    Medical Exam Requires
                </Fragment>
            );
        }
    };

    const productDetailsButton = (productName, isMobile) => {
        return (
            <Row>
                <Col>
                    <Button className={`small-text ${isMobile ? "mobile-details-button" : ""}`} color="primary" onClick={() => setIsProductDetailsDialogOpen(true)} aria-describedby={productName}>{!isMobile && `PRODUCT`} DETAILS</Button>
                </Col>
            </Row>
        );
    }

    return (
        <div className="mct-card-wrapper">
            {props.requiresMedicalExam && <div className={`ribbon ribbon-text ribbonColor`}>{getBadge()}</div>}
            <Card variant="outlined" className="highlight-quote-card">
                <CardContent className="card-content">
                    <Row className="align-items-center">
                        <Col lg={3} className={`carrier-branding-container d-flex flex-column justify-content-center align-items-center light-background-5`}>
                            <img className="carrier-logo-lg" src={props.logoUrl} alt="Breeze Icon" />
                            <div className='product-buttoncard'>{productDetailsButton(props.productName)}</div>
                        </Col>
                        <Col lg={4} className="stat-container flex-column justify-content-center">
                            <Stats
                                benefitAmount={props.benefitAmount}
                                incomeReplacement={props.incomeReplacement}
                                incomeReplacementLabel={props.incomeReplacementLabel}
                            />
                        </Col>
                        <Col lg={5} className="text-start ps-0 card-item-group">
                            <Row>
                                <Col lg={6} className="ps-0 d-flex flex-column justify-content-center">
                                    <p className="price-container">
                                        <NumericFormat
                                            className="priceColor"
                                            value={props.monthlyRate}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                        />
                                        <span className={` mt-2 quote-amount-mo priceText`}> /mo</span>
                                    </p>
                                    <p className={props.open ? 'hidden-title' : `replacementLabel mt-2 stat-title month-cost color-startitle text-center`}>Monthly Cost</p>
                                </Col>
                                <Col lg={6} className="d-flex flex-column justify-content-center ps-0 select-container">
                                    <Button className="px-4" color="primary" variant="contained" onClick={props.onClick} aria-describedby={props.productName}>
                                        Select
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </CardContent>
            </Card>

            <ProductDetailsDialog
                isOpen={isProductDetailsDialogOpen}
                productDetails={props.productDetails}
                quoteCardProps={props}
                onClose={() => setIsProductDetailsDialogOpen(false)}
            />
        </div >
    );
}

export const ProductDetailsDialog = (props) => {

    const [tooltip, setTooltip] = useState(false);

    const handleTooltipClose = () => {
        setTooltip(false);
    };

    const handleTooltipOpen = () => {
        setTooltip(true);
    };

    return (
        <Dialog className="product-details-dialog" open={props.isOpen} scroll="body" fullWidth={true} maxWidth="md" aria-labelledby="product-details-dialog">
            <DialogContent className="product-details-dialog-content">
                <IconButton
                    aria-label="close"
                    onClick={props.onClose}
                    className="close-button"
                    size="large">
                    <CloseIcon />
                </IconButton>
                <img className="carrier-logo-lg" src={props.quoteCardProps.logoUrl} alt="Breeze Icon" />

                <p className={`mt-3 textRating primary-color`}>
                    {props.quoteCardProps.rating}
                    <span className="ms-1">Rating</span>
                </p>

                <div className="product mb-1">
                    <span><h5>{props.quoteCardProps.productName}</h5></span>
                </div>

                <Row>
                    <Col xs="3" md="5">
                        <Stats
                            benefitAmount={props.quoteCardProps.benefitAmount}
                            incomeReplacement={props.quoteCardProps.incomeReplacement}
                            monthlyRate={props.quoteCardProps.monthlyRate}
                            open={props.isOpen}
                        />
                    </Col>
                    <Col md='4'></Col>
                    <Col xs="6" md="3">
                        {!props.hideSelect && <Button className={`w-100 apply ${props.quoteCardProps.hideSelect ? "d-none" : ""}`} color="primary" variant="contained" onClick={props.quoteCardProps.onClick}>
                            Select
                        </Button>}
                    </Col>
                </Row>

                <Row className='ms-2'>
                    <div >
                        <div>
                            <b>Approval Time</b><br />
                            <span className='option-info'>TBD</span>
                        </div>
                    </div>
                    <div>
                        <div className='ms-3'>
                            <b>Medical Exam</b><br />
                            <span className='option-info'>In some cases</span>
                        </div>
                    </div>
                </Row>

                <div className="product-details-info">{props.productDetails}</div>

                <div className="additional-options mt-4">
                    <strong>
                        <h5><b>Additional Options</b></h5>
                    </strong>
                    <Row>
                        {props.quoteCardProps.hasPermConversion && (
                            <Col className="mt-2 ms-2">
                                <ul className="grey-text" dangerouslySetInnerHTML={{ __html: props.quoteCardProps.convertibility }}></ul>
                            </Col>
                        )}
                    </Row>
                    {(props.quoteCardProps.availableRiders && props.quoteCardProps.availableRiders.length > 0) && (
                        <strong className="mt-4 ms-2">
                            <b>Available Policy Riders</b>
                            <Tooltip className="toolInfo ms-2" title="Riders add benefits to or change the term of an insurance policy."
                                role="tooltip" onClose={handleTooltipClose} open={tooltip} leaveTouchDelay={5000}
                                slotProps={{
                                    tooltip: {
                                        className: 'light-tooltip',
                                        sx: { fontSize: '11px' }
                                    },
                                }}>
                                <button id="riders" role="tooltip" aria-label="more about riders" className="quote-tooltip" onMouseEnter={handleTooltipOpen} onClick={handleTooltipOpen} tabIndex="0" aria-disabled="true" aria-describedby="riders">
                                    <InfoIcon color="action"></InfoIcon>
                                </button>
                            </Tooltip>
                        </strong>
                    )}

                    {props.quoteCardProps.availableRiders &&
                        props.quoteCardProps.availableRiders.length > 0 &&
                        props.quoteCardProps.availableRiders.map((r, index) => {
                            return (
                                <Row key={index}>
                                    <Col md="3">
                                        <p className="option-title font-option-title mt-2 ms-3">{r.rider}</p>
                                        {r.additionalCost && (
                                            <p className="price-extra mt-2 ms-3">
                                                <MonetizationOnOutlinedIcon /> <b className="addtional">Additional Cost</b>
                                            </p>
                                        )}
                                        {!r.additionalCost && (
                                            <p className="mt-2 ms-3 moneyIcon">
                                                <MonetizationOnOutlinedIcon /> <b className={`noAddtional noAddtionalText primary-color`}>No Additional Cost</b>
                                            </p>
                                        )}
                                    </Col>
                                    <Col>
                                        <p dangerouslySetInnerHTML={{ __html: r.description }} className="grey-text mt-1 ms-2"></p>
                                    </Col>
                                </Row>
                            );
                        })}
                </div>
            </DialogContent>
        </Dialog>
    );
};

const Stats = (props) => {
    return (
        <div className="product-details-stats">
            <Row>
                <Col lg={6} className="stat-container flex-column justify-content-center">
                    <p className="d-flex justify-content-center">
                        <NumericFormat
                            className="percentColor"
                            value={props.incomeReplacement}
                            displayType={'text'}
                            thousandSeparator={true}
                            decimalScale={2}
                            mask={'%'}
                        />
                        <span className={`quote-amount-mo priceText`}> %</span>
                    </p>
                    <p className={`replacementLabel text-center color-startitle`}>{props.incomeReplacementLabel}</p>
                </Col>
                <Col lg={6} className='d-flex flex-column justify-content-center'>
                    <p className="d-flex justify-content-center">
                        <NumericFormat
                            className="priceColor"
                            value={props.benefitAmount}
                            displayType={'text'}
                            thousandSeparator={true}
                            decimalScale={2}
                        />
                        <span className={`quote-amount-mo mt-2 priceText`}> /mo</span>
                    </p>
                    <p className={props.open ? 'hidden-title' : "stat-title color-startitle text-center"}>Benefits</p>
                </Col>
            </Row>
        </div>
    );
};

DisabilityInsuranceCard.propTypes = {
    monthlyRate: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    productDetails: PropTypes.object.isRequired,
};
